import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { TOAST_CLOSE_REASON, TOAST_CONFIG } from '../constants/toast';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectToast, toastActions } from '../store/toastSlice';

/** Displays Redux toast messages as a single global Material UI Snackbar. */
const GlobalToast: React.FC = () => {
  const dispatch = useAppDispatch();
  const toast = useAppSelector(selectToast);

  /** Closes the toast unless Material UI reports a click-away dismissal. */
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === TOAST_CLOSE_REASON.CLICKAWAY) return;
    dispatch(toastActions.closeToast());
  };

  return (
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={TOAST_CONFIG.AUTO_HIDE_DURATION_MS}
      anchorOrigin={{
        vertical: TOAST_CONFIG.ANCHOR_VERTICAL,
        horizontal: TOAST_CONFIG.ANCHOR_HORIZONTAL,
      }}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={toast?.severity}
        variant="standard"
        sx={{ width: '100%' }}
      >
        {toast?.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalToast;
